export default __webpack_public_path__ + "static/media/182.d32d77c8.gif";